export const authTokenStorageKey = 'tsync.token';
